import { Color } from '@tmh-website/shared/colors';
import styled, { css } from 'styled-components';

const iconContainerCss = css`
  flex-shrink: 0;
  transition: transform ${props => props.theme.transitionTiming};
  transform: translateX(0);

  > svg,
  img {
    display: block;
  }
`;

export const IconContainerLeft = styled.div`
  ${iconContainerCss};
`;

export const IconContainerRight = styled.div`
  ${iconContainerCss};
`;

const containerHoverCss = css<ContainerProps>`
  ${props => props.$textHoverColor && `color: ${props.theme.color[props.$textHoverColor]};`};
  text-decoration: none;

  ${IconContainerLeft}, ${IconContainerRight} {
    ${props => props.$iconHoverColor && `color: ${props.theme.color[props.$iconHoverColor]};`};
  }

  ${props =>
    props.$iconMovesOnHover &&
    css`
      ${IconContainerLeft} {
        transform: translateX(-8px);
      }
      ${IconContainerRight} {
        transform: translateX(8px);
      }
    `};

  ${props =>
    props.$transparentHover &&
    css`
      opacity: 0.8;

      &:active {
        opacity: 0.6;
      }
    `};
`;

interface ContainerProps {
  ref?: any;
  $gap?: string;
  $hasPadding?: boolean;
  $forceHover: boolean;
  $textColor?: Color;
  $textHoverColor?: Color;
  $iconColor?: Color;
  $iconHoverColor?: Color;
  $iconMovesOnHover: boolean;
  $transparentHover: boolean;
}

export const Container = styled.button<ContainerProps>`
  display: inline-flex;
  align-items: center;
  padding: ${props => (props.$hasPadding ? props.theme.gap.xSmall : 0)};
  ${props => props.$textColor && `color: ${props.theme.color[props.$textColor]};`};
  cursor: pointer;
  background: none;
  border: none;
  transition: color ${props => props.theme.transitionTiming}, opacity ${props => props.theme.transitionTiming};

  > * {
    margin-left: ${props => props.$gap};

    &:first-child {
      margin-left: 0;
    }
  }
  span {
    line-height: 1.2;
  }

  &:hover:not(:disabled) {
    ${containerHoverCss}
  }

  &:disabled {
    color: inherit;
    cursor: not-allowed;
    opacity: 0.2;

    &:active {
      pointer-events: none;
    }
  }

  ${props => props.$forceHover && containerHoverCss}
`;
